import { render } from "./Shortlist.vue?vue&type=template&id=366c7445"
import script from "./Shortlist.vue?vue&type=script&lang=js"
export * from "./Shortlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__